import React from 'react';
import Img from "../../images/services/dev/devops.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>How TekRevol Caters To DevOps?</h2>
                        <p>Our DevOps team housing developers, project managers, and testing professionals can get you at the edge of continuous technical delivery, improvement, and automation by finding the right intersection between product and solution development and business operations.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;